import PaymentPerson from "components/PaymentPerson/PaymentPerson";

const PaymentPersonPage: React.FC = () => {
  return <PaymentPerson />;
};

export default PaymentPersonPage;